module.exports = __webpack_public_path__ + "img/energy_savings_leaf_black.c58f3caf.svg";